// extracted by mini-css-extract-plugin
export default {"container":"ClientCard_container__tiMkc"};